import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormField, FormFieldOption } from '../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { ListasService } from '../../../services/listas.service';
import { AdministracionUsuariosService } from '../services/administracion-usuarios.service';
import { CrearAdminDTO } from '../models/crearAdminDTO';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-crear-administrador',
  templateUrl: './crear-administrador.component.html',
  styleUrl: './crear-administrador.component.scss',
})
export class CrearAdministradorComponent implements OnInit {
  // Campos formularios
  camposAdminLider: FormField[] = [];
  camposAdminFuncional: FormField[] = [];

  // Boolean
  esAdminLider = false;
  esAdminFuncional = false;
  mostrarEntidad = false;

  // Listas
  entidades: FormFieldOption[] = [];
  tiposAdmin: FormFieldOption[] = [];
  tiposDocumento: FormFieldOption[] = [];

  // Number
  idEntidad!: number;
  // Multilenguaje
  tableText: any = {};
  comunText: any = {};

  readonly NOMBRE_ADMIN_LIDER = 'Administrador Líder';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private listaService: ListasService,
    private adminService: AdministracionUsuariosService,
    private alertService: AlertaModalService,
    private translate: TranslateService
  ) { }
  ngOnInit(): void {
    // Se valida la ruta, para verificar si es admin líder o admin funcional
    if (this.router.url.includes('lider')) {
      this.esAdminLider = true;
      this.esAdminFuncional = false;
    } else if (this.router.url.includes('funcional')) {
      this.esAdminFuncional = true;
      this.esAdminLider = false;
      this.route.params.subscribe(params => {
        this.idEntidad = params['idEntidad'];
      });
    }

    combineLatest([
      this.translate.stream('crear-administrador'),
      this.translate.stream('comun-label'),
    ]).subscribe(([administardorText, comunLabelText]) => {
      for (let key of Object.keys(administardorText)) {
        this.tableText[key] = administardorText[key];
      }

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }
      if (this.esAdminFuncional) {
        this.inicializarFormFuncional();
      }
      if (this.esAdminLider) {
        this.inicializarFormLider();
      }
    });
    this.getListas();
  }

  getListas() {
    if (this.esAdminLider) {


      //lista de tipos de documento
      this.listaService
        .getDocumentTypeListCreateUsers()
        .subscribe(documentTypes => {
          this.tiposDocumento = documentTypes.map(documentType => ({
            Id: documentType.Id,
            Nombre: documentType.Tipo_Documento,
          }));
          this.camposAdminLider = this.camposAdminLider.map(field => {
            if (field.name === 'typeDocument') {
              field.options = documentTypes.map(documentType => ({
                Id: documentType.Id,
                Nombre: documentType.Descripcion,
              }));
            }
            return field;
          });
        });
      // Se inicializan los formularios de acuerdo al tipo de admin

      // Lista de entidades
      this.listaService.getEntidades().subscribe(entidades => {
        this.entidades = entidades.map(entidad => ({
          Id: entidad.Id ?? '',
          Nombre: entidad.Entidad || '',
        }));
        this.camposAdminLider = this.camposAdminLider.map(field => {
          if (field.name === 'entidad') {
            field.options = entidades.map(entidad => ({
              Id: entidad.Id ?? '',
              Nombre: entidad.Entidad || '',
            }));
          }
          return field;
        });
      });


      // Lista de tipos de administrador líder
      this.listaService
        .getListaValor(Constants.LISTA_TIPOS_ADMIN)
        .subscribe(tipos => {
          this.tiposAdmin = tipos;
          this.camposAdminLider = this.camposAdminLider.map(field => {
            if (field.name === 'tipoAdminLider') {
              field.options = tipos;
            }
            return field;
          });
        });
    } else if (this.esAdminFuncional) {
      this.listaService
        .getDocumentTypeListCreateUsers()
        .subscribe(documentTypes => {
          this.tiposDocumento = documentTypes.map(documentType => ({
            Id: documentType.Id,
            Nombre: documentType.Tipo_Documento,
          }));
          this.camposAdminFuncional = this.camposAdminFuncional.map(field => {
            if (field.name === 'typeDocument') {
              field.options = documentTypes.map(documentType => ({
                Id: documentType.Id,
                Nombre: documentType.Descripcion,
              }));
            }
            return field;
          });
        });
    }
  }

  // Se inicializa formulario de admin líder
  inicializarFormLider() {
    this.camposAdminLider = [
      {
        name: 'tipoAdminLider',
        label: this.tableText['tipo-admin'],
        type: 'select',
        required: true,
        width: '6',
        options: [],
        multiple: false,
        errorMessages: { required: this.tableText['campo-requerido'] },
      },
      {
        name: 'nombreUsuario',
        label: this.tableText['nombre-usuario'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(4),
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_ONLY_LETTERS_NO_SPACES),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          minlength: this.tableText['min'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'primerNombre',
        label: this.tableText['primer-nombre'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.tableText['segundo-nombre'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'primerApellido',
        label: this.tableText['primer-apellido'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.tableText['segundo-apellido'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'typeDocument',
        label: this.tableText['tipo-identificacion'],
        type: 'select',
        required: true,
        width: '6',
        options: [],
        personTypeId: '1',
        errorMessages: { required: this.tableText['campo-requerido'] },
      },
      {
        name: 'numberOfDocument',
        label: this.tableText['identificacion'],
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.max(999999999999999)],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          max: this.tableText['max-15'],
        },
      },
      {
        name: 'correo',
        label: this.tableText['correo'],
        type: 'email',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['correo-invalido'],
        },
      },
      {
        name: 'confirmarCorreo',
        label: this.tableText['confirmar-correo'],
        type: 'email',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['correo-invalido'],
          invalidField: this.tableText['no-coinciden'],
        },
      },
      {
        name: 'entidad',
        label: this.tableText['entidad'],
        type: 'select',
        required: false,
        width: '6',
        dependsOn: 'tipoAdminLider',
        options: [],
        visibilityCondition: (value: any) => {

          let id_admin_lider;
          this.tiposAdmin.forEach(item => {
            if (item.Nombre === this.NOMBRE_ADMIN_LIDER) {
              id_admin_lider = item.Id
            }
          });

          //Si es Administrador Lider, se muestra el campo de entidad
          if (value === id_admin_lider) {
            return true;
          }
          return false;

        },
        errorMessages: { required: 'El campo es requerido.' },

      },
    ];
  }

  // Se inicializa formulario de admin funcional
  inicializarFormFuncional() {
    this.camposAdminFuncional = [
      {
        name: 'nombreUsuario',
        label: this.tableText['nombre-usuario'],
        type: 'text',
        required: true,
        width: '12',
        validation: [
          Validators.minLength(4),
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_ONLY_LETTERS_NO_SPACES),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          minlength: this.tableText['min'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'primerNombre',
        label: this.tableText['primer-nombre'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.tableText['segundo-nombre'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'primerApellido',
        label: this.tableText['primer-apellido'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.tableText['segundo-apellido'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'typeDocument',
        label: this.tableText['tipo-identificacion'],
        type: 'select',
        required: true,
        width: '6',
        options: [],
        personTypeId: '1',
        errorMessages: { required: this.tableText['campo-requerido'] },
      },
      {
        name: 'numberOfDocument',
        label: this.tableText['identificacion'],
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.max(999999999999999)],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          max: this.tableText['max-15'],
        },
      },
      {
        name: 'correo',
        label: this.tableText['correo'],
        type: 'email',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['correo-invalido'],
        },
      },
      {
        name: 'confirmarCorreo',
        label: this.tableText['confirmar-correo'],
        type: 'email',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.tableText['campo-requerido'],
          pattern: this.tableText['correo-invalido'],
          maxlength: this.tableText['max-50'],
          invalidField: this.tableText['no-coinciden'],
        },
      },
    ];
  }

  onSubmitAdminLider(event: FormGroup) {
    const json: CrearAdminDTO = {
      usuarioDto: {
        username: event.value.nombreUsuario,
        primerNombre: event.value.primerNombre,
        segundoNombre: event.value.segundoNombre,
        primerApellido: event.value.primerApellido,
        segundoApellido: event.value.segundoApellido,
        tipoIdentificacion: event.value.typeDocument,
        numeroIdentificacion: event.value.numberOfDocument,
        email: event.value.correo,
      },

      tipoAdmin: [
        this.tiposAdmin.find(tipo => tipo.Id === event.value.tipoAdminLider)
          ?.Nombre ?? '',
      ],
      entidad: event.value.entidad,
    };

    this.adminService.crearUsuario(json).subscribe(resp => {
      if (resp.success) {
        this.alertService.exito(resp.message).then(() => {
          this.router.navigateByUrl(
            'administracion-usuarios/lista-administradores'
          );
        });
      } else {
        this.alertService.error(resp.message);
      }
    });
  }

  onSubmitAdminFuncional(event: FormGroup) {
    const json: CrearAdminDTO = {
      usuarioDto: {
        username: event.value.nombreUsuario,
        primerNombre: event.value.primerNombre,
        segundoNombre: event.value.segundoNombre,
        primerApellido: event.value.primerApellido,
        segundoApellido: event.value.segundoApellido,
        tipoIdentificacion: event.value.typeDocument,
        numeroIdentificacion: event.value.numberOfDocument,
        email: event.value.correo,
      },
      entidad: this.idEntidad,
      tipoAdmin: ['Administrador Funcional'],
    };
    this.adminService.crearUsuario(json).subscribe(resp => {
      if (resp.success) {
        this.alertService.exito(resp.message).then(() => {
          this.router.navigateByUrl(
            'administracion-usuarios/lista-administradores'
          );
        });
      } else {
        this.alertService.error(resp.message);
      }
    });
  }

  validarCorreo(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = event.form;
    if (event.controlName === 'confirmarCorreo') {
      if (event.controlValue === undefined) {
        event.form.controls['confirmarCorreo'].markAsDirty();
        event.form.controls['confirmarCorreo'].markAllAsTouched();
      } else {
        const correo = event.form.controls['correo'].value;
        if (correo !== '' && event.controlValue !== correo) {
          event.form.controls['confirmarCorreo'].setErrors({
            'is-invalid': true,
          });
        } else {
          event.form.controls['confirmarCorreo'].setValidators(
            Validators.maxLength(50)
          );
        }
      }
    }

    if (event.controlName === 'correo') {
      if (event.controlValue === undefined) {
        event.form.controls['correo'].markAsDirty();
        event.form.controls['correo'].markAllAsTouched();
      } else {
        const confirmarCorreo = event.form.controls['confirmarCorreo'].value;
        if (
          event.controlValue !== '' &&
          event.controlValue !== confirmarCorreo
        ) {
          event.form.controls['confirmarCorreo'].setErrors({
            'is-invalid': true,
          });
        } else {
          event.form.controls['confirmarCorreo'].setValidators(
            Validators.maxLength(50)
          );
        }
      }
    }
    if (this.esAdminLider) {
      const numeroDocumentoAdminLider = this.camposAdminLider.find(
        field => field.name == 'numberOfDocument'
      );
      if (
        event.controlName == 'typeDocument' ||
        event.controlName == 'numberOfDocument'
      ) {
        let idTipoDocumento: number = +formGroup.get('typeDocument')?.value;
        let identificacion: string = formGroup.get('numberOfDocument')?.value;
        if (idTipoDocumento !== null && identificacion !== null) {
          if (
            idTipoDocumento == 1 ||
            idTipoDocumento == 2
          ) {
            if (numeroDocumentoAdminLider != undefined) {
              formGroup
                .get('numberOfDocument')
                ?.setValidators([
                  Validators.required,
                  Validators.minLength(4),
                  Validators.maxLength(12),
                  Validators.pattern(/^\d+$/),
                ]);
              numeroDocumentoAdminLider.errorMessages!['maxlength'] =
                this.comunText['numero-documento-maxlength'];
              numeroDocumentoAdminLider.errorMessages!['minlength'] =
                this.comunText['numero-documento-minlength'];
              numeroDocumentoAdminLider.errorMessages!['pattern'] =
                this.comunText['numero-documento-pattern'];
            }
          } else if (idTipoDocumento == 4) {
            if (numeroDocumentoAdminLider != undefined) {
              formGroup
                .get('numberOfDocument')
                ?.setValidators([
                  Validators.required,
                  Validators.minLength(4),
                  Validators.maxLength(8),
                  Validators.pattern(
                    Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                  ),
                ]);
              numeroDocumentoAdminLider.errorMessages!['maxlength'] =
                this.comunText['numero-documento-maxlength-ce'];
              numeroDocumentoAdminLider.errorMessages!['minlength'] =
                this.comunText['numero-documento-minlength'];
              numeroDocumentoAdminLider.errorMessages!['pattern'] =
                this.comunText['numero-documento-pattern-ce'];
            }
          }
          formGroup.get('numberOfDocument')?.updateValueAndValidity();
        }
      }
    } else if (this.esAdminFuncional) {
      let idTipoDocumento: number = +formGroup.get('typeDocument')?.value;
      let identificacion: string = formGroup.get('numberOfDocument')?.value;
      const numeroDocumentoAdminFuncional = this.camposAdminFuncional.find(
        field => field.name == 'numberOfDocument'
      );
      if (
        event.controlName == 'typeOfDocument' ||
        event.controlName == 'numberOfDocument'
      ) {
        if (idTipoDocumento !== null && identificacion !== null) {
          if (
            idTipoDocumento == 1 ||
            idTipoDocumento == 2
          ) {
            if (numeroDocumentoAdminFuncional != undefined) {
              formGroup
                .get('numberOfDocument')
                ?.setValidators([
                  Validators.required,
                  Validators.minLength(4),
                  Validators.maxLength(12),
                  Validators.pattern(/^\d+$/),
                ]);
              numeroDocumentoAdminFuncional.errorMessages!['maxlength'] =
                this.comunText['numero-documento-maxlength'];
              numeroDocumentoAdminFuncional.errorMessages!['minlength'] =
                this.comunText['numero-documento-minlength'];
              numeroDocumentoAdminFuncional.errorMessages!['pattern'] =
                this.comunText['numero-documento-pattern'];
            }
          } else if (idTipoDocumento == 4) {
            if (numeroDocumentoAdminFuncional != undefined) {
              formGroup
                .get('numberOfDocument')
                ?.setValidators([
                  Validators.required,
                  Validators.minLength(4),
                  Validators.maxLength(8),
                  Validators.pattern(
                    Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                  ),
                ]);
              numeroDocumentoAdminFuncional.errorMessages!['maxlength'] =
                this.comunText['numero-documento-maxlength-ce'];
              numeroDocumentoAdminFuncional.errorMessages!['minlength'] =
                this.comunText['numero-documento-minlength'];
              numeroDocumentoAdminFuncional.errorMessages!['pattern'] =
                this.comunText['numero-documento-pattern-ce'];
            }
          }
          formGroup.get('numberOfDocument')?.updateValueAndValidity();
        }
      }
    }
  }
}
